import React from "react";
import classes from "./Header.scss";

const Header = props => {
  const { closeButtonElement, t, headerStyle } = props;

  return (
    <div className={classes.header} style={headerStyle}>
      <h6>{`${t("common:select_with_label", {
        label: t("snp:practice_or_requirement"),
      })}`}</h6>
      {closeButtonElement}
    </div>
  );
};

export default Header;
